import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const I18nLoaderContext = /*#__PURE__*/createContext(undefined);
export function I18nLoaderProvider({
  children,
  i18nLoader
}) {
  return /*#__PURE__*/_jsx(I18nLoaderContext.Provider, {
    value: i18nLoader,
    children: children
  });
}